import React, { ChangeEvent, Fragment, ReactNode } from 'react';

import { connect } from 'react-redux';

import { AppState, Actions, store, IPageState, DisplayState } from 'appredux';


import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import theme from 'themes';
import Typography from '@material-ui/core/Typography';


import { Tooltip, Icon, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Link, FormControl, InputAdornment, IconButton } from '@material-ui/core';

import  { SelectChangeEvent } from '@mui/material/Select';
import Select from '@material-ui/core/Select';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@material-ui/core/TextField';
import { ThemeProvider } from '@mui/material';
import { capitalizeFirstLetter } from 'common/helpers';

import DialpadIcon from '@mui/icons-material/Dialpad';
import Klawiatura from './Klawiatura';

interface DialogProps extends WithStyles<typeof styles> {
    page: IPageState,
    windowWidth: number,
    open: boolean,
    send: () => void,
    close: () => void,
}

interface DialogState {
    telefon: string,
    imie: string,
    openKlawiatura1: boolean
}

class DialogKontakt extends React.Component<DialogProps, DialogState>  {
    stylInputaIlePokoi: React.CSSProperties = { padding: "6px 14px", textAlign: "left", fontSize: "13px" };

    //PM 2021-09-17
    constructor(props: DialogProps) {
        super(props, {});
        this.state = {
            telefon: "",
            imie: "",
            openKlawiatura1: false
        }
    }

   
    setOpenKlawiatura1 = () => {
      this.setState({openKlawiatura1: true})
    }
    setCloselawiatura1 = (focusNext: boolean) => {
      this.setState({openKlawiatura1: false})
     
    } 
    setTelefonKlawiatura = (tel: string) => {
      this.setState({ telefon: tel })
    }

      onChangeTelefon = (event: React.ChangeEvent<{ name?: string; value: unknown; }>) => {
        this.setState({ telefon: String(event.target.value) })
      }
      onChangeImie = (event: React.ChangeEvent<{ name?: string; value: unknown; }>) => {
        this.setState({ imie: String(event.target.value) })
      }

      preventKeys = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === "e" || e.key === "E" || e.key === "-" || e.key === "+") {
          e.preventDefault()
        }
    }
  

    render() {
        const classes = this.props.classes;
       
        return (
            <>
                {/* <Dialog
                    //disableEscapeKeyDown
                    maxWidth="sm"
                    open={this.props.open}
                    onEscapeKeyDown={this.props.close}
                    onBackdropClick={this.props.close}
                    fullWidth
                > */}
                    {/* <DialogTitle disableTypography >
                        <Typography gutterBottom variant="h6" component="h2" align='center'
                            className={`${classes.headline} ${classes.primary}`}>
                            <b style={{ textTransform: "lowercase" }}>{'test'}</b>
                        </Typography>
                        <hr style={{ marginTop: "10px", borderBottom: "0px" }} />
                    </DialogTitle> */}
                    

                    <DialogContent  style={{paddingBottom: "20px"}}>
              <div style={{ display: "flex", justifyContent: "center" }} >
                <div className={classes.shadow} style={{ width: "500px" }}>
                  <DialogContentText className={classes.dialogContentText} >
                    {"To jest przykładowe info wysłane ze strony "} <Link href='www.virtualsc.com.pl'>www.virtualsc.com.pl</Link>
                  </DialogContentText>
                  <DialogContentText className={classes.dialogContentText} >
                    {"To jest link do strony "} <Link href='www.virtualsc.com.pl'>www.virtualsc.com.pl</Link>
                  </DialogContentText>

                

                </div>
              </div>

              <DialogContentText className={classes.dialogContentText} >
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                        </DialogContentText>


                        <div style={{display: "flex", justifyContent: "center"}}>
                        <div className={classes.shadow} style={{width: "400px"}}>
                        <div style={{margin: "auto", width: "fit-content"}}>
                        <FormControl //style={{paddingLeft: "24px"}}
                                variant="outlined"  margin="dense" fullWidth
                                className={classes.formControl}
                              >
                                  <label className={`${classes.label} ${classes.labelColor}`} >Wpisz swój nr telefonu</label>
                                  <TextField
                                    autoFocus
                                    id={"0"}
                                    type={'number'}
                                    className={classes.inputWidth} 
                                    //style={this.props.style}
                                    variant="outlined"
                                    inputProps={{ style: this.stylInputaIlePokoi }}
                                    InputProps={{ classes: { input: `${classes.textField} ${classes.textFieldEnabled}` },
                                    endAdornment: ( <InputAdornment position="start" style={{ padding: "0" }} >

                                    <IconButton id="klawiaturaIcon1"
                                      aria-label="more"
                                      aria-controls="long-menu"
                                      aria-haspopup="true"
                                      onClick={this.setOpenKlawiatura1}
                                      style={{ padding: "4px", marginRight: "-14px" }}
                                    >
                                        <DialpadIcon style={{ fontSize: "1rem" }} />
                                    </IconButton>
                                    <Klawiatura open={this.state.openKlawiatura1} number={Number(this.state.telefon)} setNumber={this.setTelefonKlawiatura} close={this.setCloselawiatura1} title={"wpisz telefon"} placeholder="606 257 683" phoneMode max={9} error={""}/>
                                  </InputAdornment>)}}
                                    value={this.state.telefon.toString()}
                                    //disabled={this.props.disabled}
                                    onKeyDown={this.preventKeys}
                                    onChange={this.onChangeTelefon}
                                    placeholder='606 257 683'
                                  />
                              </FormControl>
                        <FormControl //style={{paddingLeft: "24px"}}
                                variant="outlined"  margin="dense" fullWidth
                                className={classes.formControl}
                              >
                                  <label className={`${classes.label} ${classes.labelColor}`} >Wpisz swoje imię</label>
                                  <TextField
                                    id={"1"}
                                    //type={'number'}
                                    className={classes.inputWidth} 
                                    //style={this.props.style}
                                    variant="outlined"
                                    inputProps={{ style: this.stylInputaIlePokoi }}
                                    InputProps={{ classes: { input: `${classes.textField} ${classes.textFieldEnabled}` }, }}
                                    value={capitalizeFirstLetter(this.state.imie)}
                                    //disabled={this.props.disabled}
                                    //onKeyDown={this.preventKeys}
                                    onChange={this.onChangeImie}
                                    placeholder='Moje imię'
                                  />
                              </FormControl>


                             
                              </div>
                              </div>
                          </div>
                    
                          <DialogContentText className={classes.dialogContentText} >
                        </DialogContentText>

                          <DialogContentText style={{ textAlign: "center", paddingTop: "20px" }} >
                                <Button variant="contained" color="primary" size="large" className={classes.button}
                                  onClick={this.props.send} style={{}}>
                                  <b>wyślij sms</b>
                                </Button>
                              </DialogContentText>


                    </DialogContent>
                    {/* <DialogActions>
                        <Button variant="contained" color="primary" size="small" className={classes.button}
                            onClick={this.props.send}>
                            <b>wyślij sms</b>
                        </Button>
                        <Button variant="outlined" color="primary" size="small" className={classes.button}
                            onClick={this.props.close}>
                            <b>wróć</b>
                        </Button>
                    </DialogActions>
                </Dialog> */}
            </>

        );
    }
}

const styles = (theme: Theme) => ({
    primary: {
        color: theme.palette.primary.main
      },
      secondary: {
        color: theme.palette.secondary.main
      },
      error: {
          color: "rgb(244, 67, 54)"
      },
      paddingBottom0: {
        paddingBottom: 0
      },
      headline: {
        //fontFamily: "\"'Open Sans'\", sans-serif",
        lineHeight: "20px",
        fontSize: "15px",
        //fontWeight: 600
      },
      dialogContentText: {
        color: theme.palette.primary.main,
        //color: theme.palette.text.secondary,
        //whiteSpace: "pre" as "pre",
        minHeight: "12px",
        marginBottom: '6px',
        fontSize: "15px",
        textAlign: "center" as "center"
      },
      button: {
        textTransform: "none" as "none",
        fontSize: "14px",
        width: "200px",
    },

   
      textField: {
        //color: "rgb(0, 0, 0)",
        //color: theme.palette.primary.main,
        //color: 'seagreen',
        padding: "8px 14px",
        fontSize: '16px',
        float: "left" as "left",
        textAlign: "left" as "left",
        fontWeight: "normal" as "normal"
        
      },
      textFieldDisabled: {
        color: theme.palette.primary.main,
      },
      textFieldEnabled: {
        //color: "orange",
        color: theme.palette.primary.main,
        //fontWeight: "bold" as "bold"
      },



      inputWidth: {
        //width: "15%",
        width: "166px",
        display: "inline-flex" as "inline-flex"
      },
      label: {
        //color: theme.palette.primary.main,
        //color: theme.palette.text.secondary,
        //fontFamilly: "sans-serif",
        //fontSize: "small"
        fontSize: "13px",
        fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
        lineHeight: "20px",
        fontWeight: theme.typography.body2.fontWeight,
        //paddingLeft: "20px",
        //padding: "7px 0 4px",
        marginRight: "10px",
        width: "144px",
       // width: "calc(100% + -85px)",
        display: "inline-block" as "inline-block"
      },
      labelColor: {
        color: theme.palette.text.secondary,
        //color: theme.palette.primary.main,
      },
      formControl: {
        //display: "block",
        //paddingBottom: "35px"
        marginTop: "0px", //4px
        display: "flex" as "flex",
        //display: "inline-flex" as "inline-flex",
        alignItems: "center" as "center",
        flexDirection: "row" as "row",   
    },
    shadow: {
      boxShadow: "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
      padding: "18px 15px 15px 20px",
      borderRadius: "4px"
    }

});

const mapStateToProps = (state: AppState) => ({
    page: state.pageState,
});

export default connect(mapStateToProps)(withStyles(styles)(DialogKontakt));

